export enum PageDimensions {
	US_LETTER = 'US_LETTER',
	US_LETTER_LANDSCAPE = 'US_LETTER_LANDSCAPE',
	A4 = 'A4',
	A4_LANDSCAPE = 'A4_LANDSCAPE'
}
